import React from "react";
import { Field, FieldArray, Formik } from "formik";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  Modal,
} from "../../../components";

const UpdateLimit = ({
  item,
  loading,
  onSubmit,
  closeModal,
  currencyCodes,
  validationSchema,
}) => {
  const FieldInput = ({ field, ...props }) => {
    return <MimaInput {...field} {...props} />;
  };

  const FieldDropDown = ({ field, ...props }) => {
    return <MimaDropdown {...field} {...props} />;
  };
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7">
        Update Money-Ex limit
      </MimaText>
      <Formik
        initialValues={{
          daily: item.daily.map((entry) => ({
            currencyCode: entry.currencyCode || "",
            value: entry.value || 0,
          })),
          weekly: item.weekly.map((entry) => ({
            currencyCode: entry.currencyCode || "",
            value: entry.value || 0,
          })),
          monthly: item.monthly.map((entry) => ({
            currencyCode: entry.currencyCode || "",
            value: entry.value || 0,
          })),
          grade: item.grade || "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <>
              <MimaText variant="smallBold" mb={2}>
                Daily Limit
              </MimaText>
              <FieldArray name="daily">
                {({ push, remove }) => (
                  <React.Fragment>
                    {values.daily.map((_, i) => (
                      <div key={i}>
                        <div className="modal__beside">
                          <Field
                            name={`daily.${i}.currencyCode`}
                            component={FieldDropDown}
                            value={values.daily?.[i]?.currencyCode || ""}
                            placeholder={
                              values.daily?.[i]?.currencyCode ||
                              "Select Currency"
                            }
                            data={currencyCodes}
                            onChange={(data) => {
                              setFieldValue(
                                `daily.${i}.currencyCode`,
                                data.key
                              );
                            }}
                            labelTitle="Currency code"
                            width={18}
                            touched={touched?.daily?.[i]?.key}
                            error={errors?.daily?.[i]?.key}
                          />
                          <Field
                            name={`daily.${i}.value`}
                            component={FieldInput}
                            type="number"
                            labelTitle="Limit Amount"
                            width={18}
                            touched={touched?.daily?.[i]?.value}
                            error={errors?.daily?.[i]?.value}
                          />
                        </div>
                        {i !== 0 ? (
                          <MimaButton
                            title="Remove"
                            variant="filter"
                            type="button"
                            buttonColor="var(--color-error)"
                            width={10}
                            onClick={() => remove(i)}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ))}
                    <MimaButton
                      title="Add Another Daily Limit"
                      variant="text"
                      type="button"
                      onClick={() =>
                        push({
                          currencyCode: "",
                          value: 0,
                        })
                      }
                      width={38}
                      mb={2}
                    />
                  </React.Fragment>
                )}
              </FieldArray>
            </>
            <>
              <MimaText variant="smallBold" mb={2} mt={3}>
                Weekly Limit
              </MimaText>
              <FieldArray name="weekly">
                {({ push, remove }) => (
                  <React.Fragment>
                    {values.weekly.map((_, i) => (
                      <div key={i}>
                        <div className="modal__beside">
                          <Field
                            name={`weekly.${i}.currencyCode`}
                            component={FieldDropDown}
                            value={values.weekly?.[i]?.currencyCode || ""}
                            placeholder={
                              values.weekly?.[i]?.currencyCode ||
                              "Select Currency"
                            }
                            data={currencyCodes}
                            onChange={(data) => {
                              setFieldValue(
                                `weekly.${i}.currencyCode`,
                                data.key
                              );
                            }}
                            labelTitle="Currency code"
                            width={18}
                            touched={touched?.weekly?.[i]?.key}
                            error={errors?.weekly?.[i]?.key}
                          />
                          <Field
                            name={`weekly.${i}.value`}
                            component={FieldInput}
                            type="number"
                            labelTitle="Limit Amount"
                            width={18}
                            touched={touched?.weekly?.[i]?.value}
                            error={errors?.weekly?.[i]?.value}
                          />
                        </div>
                        {i !== 0 ? (
                          <MimaButton
                            title="Remove"
                            variant="filter"
                            type="button"
                            buttonColor="var(--color-error)"
                            width={10}
                            onClick={() => remove(i)}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ))}
                    <MimaButton
                      title="Add Another Weekly Limit"
                      variant="text"
                      type="button"
                      onClick={() =>
                        push({
                          currencyCode: "",
                          value: 0,
                        })
                      }
                      width={38}
                      mb={2}
                    />
                  </React.Fragment>
                )}
              </FieldArray>
            </>
            <>
              <MimaText variant="smallBold" mb={2} mt={3}>
                Monthly Limit
              </MimaText>
              <FieldArray name="monthly">
                {({ push, remove }) => (
                  <React.Fragment>
                    {values.monthly.map((_, i) => (
                      <div key={i}>
                        <div className="modal__beside">
                          <Field
                            name={`monthly.${i}.currencyCode`}
                            component={FieldDropDown}
                            value={values.monthly?.[i]?.currencyCode || ""}
                            placeholder={
                              values.monthly?.[i]?.currencyCode ||
                              "Select Currency"
                            }
                            data={currencyCodes}
                            onChange={(data) => {
                              setFieldValue(
                                `monthly.${i}.currencyCode`,
                                data.key
                              );
                            }}
                            labelTitle="Currency code"
                            width={18}
                            touched={touched?.monthly?.[i]?.key}
                            error={errors?.monthly?.[i]?.key}
                          />
                          <Field
                            name={`monthly.${i}.value`}
                            component={FieldInput}
                            type="number"
                            labelTitle="Limit Amount"
                            width={18}
                            touched={touched?.monthly?.[i]?.value}
                            error={errors?.monthly?.[i]?.value}
                          />
                        </div>
                        {i !== 0 ? (
                          <MimaButton
                            title="Remove"
                            variant="filter"
                            type="button"
                            buttonColor="var(--color-error)"
                            width={10}
                            onClick={() => remove(i)}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ))}
                    <MimaButton
                      title="Add Another Monthly Limit"
                      variant="text"
                      type="button"
                      onClick={() =>
                        push({
                          currencyCode: "",
                          value: 0,
                        })
                      }
                      width={38}
                      mb={2}
                    />
                  </React.Fragment>
                )}
              </FieldArray>
            </>

            <MimaInput
              labelTitle="Grade"
              placeholder="Enter grade"
              id="grade"
              name="grade"
              disabled
              value={values?.grade}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.grade}
              touched={touched.grade}
              mb={2}
              mt={2}
            />

            <MimaButton
              title="Continue"
              width={38}
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>{" "}
    </Modal>
  );
};
export default UpdateLimit;
